'use es6';

import DashedLabel from '../atoms/DashedLabel';
import I18n from 'I18n';
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
import ContentText from '../atoms/ContentText';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPlainText, getRichText } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { isDuringOfficeHours } from './operators/isDuringOfficeHours';
import PropTypes from 'prop-types';
import { OFFICE_HOURS } from 'conversations-message-history/office-hours-message/constants/messageTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const AvailabilityMessage = ({
  message
}) => {
  if (message['@type'] !== OFFICE_HOURS && !hasTextContent(message)) {
    return null;
  }
  if (isDuringOfficeHours(message)) return null;
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    labelPadding: "m-y-1",
    children: /*#__PURE__*/_jsx(ContentText, {
      messageId: message.id,
      "aria-label": `${I18n.text('conversations-visitor-message-history.systemMessage')} ${getPlainText(message)}`,
      contentText: getRichText(message) || getPlainText(message)
    })
  });
};
AvailabilityMessage.displayName = 'AvailabilityMessage';
AvailabilityMessage.propTypes = {
  message: PropTypes.oneOfType([RecordPropType('TypicalResponseTimeMessage'), RecordPropType('OfficeHoursMessage')]).isRequired
};
export default AvailabilityMessage;